export default __webpack_public_path__ + "static/media/qr-code-scan.6001dada.svg";